import React, {
  useCallback,
  useMemo,
} from 'react';
import PropTypes from 'prop-types';

import { AccordionSet } from '@folio/stripes/components';
import CheckboxFilter from '../../common/filters/checkbox-filter';

import {
  STATUSES_FILTER_PARAMETER,
  JOB_MODULE_NAME,
} from '../../../constants';
import {
  applyFiltersAdapter,
  getCheckboxFilterOptions,
} from '../../../utils';

const JobListFilters = ({
  activeFilters,
  applyFilters,
  jobStatuses,
}) => {
  const adaptedApplyFilters = useCallback(
    applyFiltersAdapter(applyFilters),
    [applyFilters],
  );

  const getStatusDataOptions = useMemo(() => (
    getCheckboxFilterOptions(
      JOB_MODULE_NAME,
      STATUSES_FILTER_PARAMETER,
      jobStatuses,
    )), [jobStatuses]);

  return (
    <AccordionSet data-jobs-status-filter>
      <CheckboxFilter
        activeFilters={activeFilters[STATUSES_FILTER_PARAMETER]}
        id={STATUSES_FILTER_PARAMETER}
        labelId="ui-task-list.job.list.field.status"
        name={STATUSES_FILTER_PARAMETER}
        options={getStatusDataOptions}
        onChange={adaptedApplyFilters}
      />
    </AccordionSet>
  );
};

JobListFilters.propTypes = {
  activeFilters: PropTypes.object.isRequired,
  applyFilters: PropTypes.func.isRequired,
  jobStatuses: PropTypes.array.isRequired,
};

export default JobListFilters;
